// services/publicBooking.api.js
import api from "./api";

export const PublicBookingAPI = {
  async getTicket(id) {
    if (!id) throw new Error("Booking ID required");

    const res = await api.get(`/api/bookings/${id}/ticket`);
    return res.data;
  },

  async getStatus(id) {
    if (!id) throw new Error("Booking ID required");

    const res = await api.get(`/api/bookings/${id}/status`);
    return res.data;
  },

  async uploadPaymentProof(id, formData) {
    if (!id) throw new Error("Booking ID required");

    return api.post(
      `/api/bookings/${id}/payment-proof`,
      formData
    );
  },
};
